<template>
  <div>
    <v-row class="mt-4 mb-8 pl-2" align="center">
      <v-icon large>mdi-cog</v-icon>
      <h2 class="text-h5 d-inline pl-2">Módulo PABX</h2>
    </v-row>
    <v-row no-gutters>
      <h3 class="text-h6">Geral</h3>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoPABX"
          :items="permissionsPABX"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { registerVuexModule } from "@/utils/vuexUtils";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";
import { addAndRemovePermissions } from "../_utils/addAndRemovePermissions";
import { dictionaryRoles } from "../_utils/dictionaryRoles";

import roleStore from "../_store";

export default {
  data: () => ({
    permissaoVisualizar: false,
    initPermissoes: false,
    // Geral
    permissionsPABX: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.pabxHabilitado.description,
        value: dictionaryRoles.pabxHabilitado.id,
      },
    ],
    selecionadoPABX: null,
  }),

  computed: {
    ...mapGetters("moduloPABXStepStore", ["getPermissoes"]),
  },

  async created() {
    this.initPermissoes = false;
    registerVuexModule(this.$store, "moduloPABXStepStore", roleStore);

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    if (
      arrayPermissions.includes(
        process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_VISUALIZAR
      )
    ) {
      this.permissaoVisualizar = true;
    }
  },

  methods: {
    ...mapActions("moduloPABXStepStore", [
      "addPermissionsID",
      "deletePermissionsID",
    ]),
    ...obtainUserPermissions,
    ...addAndRemovePermissions,
  },

  watch: {
    // Monitora permissoes
    getPermissoes: {
      deep: true,
      handler(newValue) {
        if (!this.initPermissoes) {
          this.initPermissoes = true;
          if (
            newValue.includes(dictionaryRoles.pabxHabilitado.id) &&
            !this.initpermitionPabx
          ) {
            this.selecionadoPABX = dictionaryRoles.pabxHabilitado.id;
            this.initpermitionPabx = true;
          }
        }
      },
    },
    //Monitora Selects
    selecionadoPABX: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
  },
};
</script>
